import { PremierServiceProductDTO } from "../DTO/premierServiceProductDTO";
import { BasicRequest } from "./basicRequest";

export class UpdatePremierServiceProductRequest extends BasicRequest{

    public premierServiceProduct!: PremierServiceProductDTO;

    constructor(){
        super();
    }
}